module.exports = __webpack_public_path__ + "media/images/home/courses_icon-3eda18411286e8b7e25a745556a445eb.svg";